(function () {
  'use strict';
  var link = document.querySelector('.header-cta');
  if (!link) return;
  link.addEventListener('click', function (event) {
    if (link.getAttribute('href') !== '#traceform-upload-heading') return;
    var upload = document.getElementById('traceform-upload');
    if (!upload) return;
    event.preventDefault();
    // iOS WebKit can update the fragment without scrolling after file selection.
    // Position the actual upload control below the sticky header explicitly.
    history.replaceState(history.state, '', '#traceform-upload-heading');
    requestAnimationFrame(function () {
      var header = document.querySelector('.site-header');
      var inset = header ? header.getBoundingClientRect().height : 0;
      window.scrollTo({ top: Math.max(0, window.scrollY + upload.getBoundingClientRect().top - inset - 24), behavior: 'instant' });
    });
  });
}());
